import React from 'react';
import styled from 'styled-components';

import { Col } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Column = styled(Col)`
  margin-bottom: ${({ mBottom }) => mBottom}px;
`;

const ReferralWeightedExperiments = ({ weightedExperiments }) => {
  const experimentsNameArr =
    (Array.isArray(weightedExperiments) && weightedExperiments[0]) || [];
  const percentageArr =
    (Array.isArray(weightedExperiments) && weightedExperiments[1]) || [];
  return (
    <>
      {experimentsNameArr?.map((el, i) => {
        return (
          <Column mBottom={24} gutter={8} key={el}>
            <Text variant="eyebrow2">{el}</Text>
            <Text variant="h6">{percentageArr[i] * 100}%</Text>
          </Column>
        );
      })}
    </>
  );
};

export default ReferralWeightedExperiments;
